export function isEmptyHtml(html) {
    if (!html)
        return true;
    const withoutTags = html
        .replace(/<[^>]*>/g, '')
        .replace(/&nbsp;/gi, ' ')
        .replace(/\u200B/g, '')
        .trim();
    if (withoutTags.length > 0)
        return false;
    if (typeof window !== 'undefined') {
        const doc = new DOMParser().parseFromString(html, 'text/html');
        const meaningful = doc.body.querySelector('img, video, iframe, audio, embed, object, svg, table td, table th, pre, code, ul li, ol li');
        return !meaningful;
    }
    return true;
}
